export default __webpack_public_path__ + "static/media/Abyssal Demon Pendant of Wisdom.577990fc.jpg";